module.exports = __webpack_public_path__ + "static/media/31.3348d910.png";